import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolDesignHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/funnel/")({
    component: FunnelDesignPage,
    staticData: {
        permissions: [PermissionEnum.ToolDesignFunnel],
        showInSideMenu: false,
        label: "pages.tool.design.funnel.title",
    },
    loader: ({ context: { t } }) => {
        return { breadcrumb: t("pages.tool.design.funnel.title") };
    },
});

function FunnelDesignPage() {
    return <TenantPage headerNavigationItems={getToolDesignHeaderItems}>{""}</TenantPage>;
}
